import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const TARGET = new Date(2026, 10, 17, 18, 0, 0);

const UNITS = [
  { key: "days", label: "დღე" },
  { key: "hours", label: "საათი" },
  { key: "minutes", label: "წუთი" },
  { key: "seconds", label: "წამი" },
];

function getRemaining() {
  const diff = Math.max(0, TARGET.getTime() - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
}

export default function CountdownTimer() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = setInterval(() => setRemaining(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid="countdown-timer" className="space-y-4 pt-1">
      <p className="eyebrow !text-[10px]">ქორწილამდე დარჩა</p>
      <div className="flex items-stretch justify-center gap-2.5 sm:gap-3.5">
        {UNITS.map((unit) => {
          const value = String(remaining[unit.key]).padStart(2, "0");
          return (
            <div
              key={unit.key}
              data-testid={`countdown-${unit.key}`}
              className="gold-frame flex w-16 flex-col items-center bg-white py-3 sm:w-[72px]"
            >
              <span className="relative flex h-8 items-center justify-center overflow-hidden">
                <AnimatePresence mode="popLayout" initial={false}>
                  <motion.span
                    key={value}
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    transition={{ duration: 0.35, ease: "easeOut" }}
                    className="font-display gold-text text-2xl leading-none tabular-nums sm:text-[28px]"
                  >
                    {value}
                  </motion.span>
                </AnimatePresence>
              </span>
              <span className="mt-1.5 text-[9px] uppercase tracking-[0.2em] text-[#A1A1AA]">
                {unit.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
